import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import TextArea from '../../../common/components/TextArea.js'
import apiverson from '../../../common/apiverson.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {stocktakeSelector, updateStocktake} from '../../../data/stocktakes.js'

const MODAL_FORM = 'add_stocktake_comment_modal'

export function showAddStocktakeCommentModal(referenceID) {
  setForm(MODAL_FORM, {
    referenceID,
    comment: '',
    isSaving: false,
    serverError: null,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function close() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  return formsSelector(state)[MODAL_FORM]
}

export async function addStocktakeComment() {
  try {
    updateModalForm({isSaving: true})

    const {referenceID, comment} = modalFormSelector(getState())

    const {json} = await apiverson.post(
      `/stocktake/${encodeURIComponent(referenceID)}/comment`,
      {comment},
    )

    const {comments} = stocktakeSelector(getState(), {referenceID})

    if (comments) {
      updateStocktake(referenceID, {comments: [json, ...comments]})
    }

    showMessageToast('Stocktake comment was added.')

    close()
  } catch (err) {
    updateModalForm({
      serverError: `Error creating Stocktake comment: ${
        err.message || err.error_message
      }`,
      isSaving: false,
    })
  }
}

function AddStocktakeCommentModal({form}) {
  return (
    <ConfirmModal
      title="Add Stocktake Comment"
      confirmText="Save"
      cancelText="Cancel"
      onConfirm={() => addStocktakeComment()}
      onCancel={() => close()}
      isSaving={form.isSaving}
      error={form.serverError}
    >
      <ul className="list list--no-style">
        <li className="list__item--form list__item--no-style divider--bottom">
          <div className="fs-01">
            <strong>{form.referenceID}</strong>
          </div>
        </li>
        <li>
          <TextArea
            label="Comment"
            rows="10"
            id="comment"
            value={form.comment}
            onChange={(value) => updateModalForm({comment: value})}
            autoFocus
          />
        </li>
      </ul>
    </ConfirmModal>
  )
}

export default onlyIfForm(AddStocktakeCommentModal, modalFormSelector)
